import React, { useState, useEffect } from "react";
import axios from "axios";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Table from "components/Table/Table.js";
import EditTable from 'components/Table/EditTable.js';
import Button from "components/CustomButtons/Button.js";

import styles from 'views/component/Styles.js';
import Confirm from 'views/component/Confirm.js';

const useStyles = makeStyles(styles);

export default function ManagementPage(props) {
    const { location } = props;
    const classes = useStyles();

    // default table data
    const [projectData, setProjectData] = useState([]);
    const [userData, setUserData] = useState([]);

    // editable table data
    const [projectDataEdit, setProjectDataEdit] = useState([]);
    const [removedProjectList, setRemovedProjectList] = useState([]);
    const [userDataEdit, setUserDataEdit] = useState([]);
    const [removedUserList, setRemovedUserList] = useState([]);
    const [checkSelects, setCheckSelects] = useState();

    // editable toggle
    const [editableProjectList, setEditableProjectList] = useState(false);
    const [editableUserList, setEditableUserList] = useState(false);

    // confirm popup toggle
    const [projectConfirm, showProjectConfirm] = useState(false);
    const [userConfirm, showUserConfirm] = useState(false);

    // create button div toggle
    const [showProjectCreateDiv, setProjectCreateDiv] = useState(true);
    const [showUserCreateDiv, setUserCreateDiv] = useState(true);

    // project
    useEffect(() => {
        axios.get('data/project/list')
            .then(response => {
                let projectList = response.data;
                if (window.sessionStorage.getItem('isAdmin') === 'false'){
                    const auth = window.sessionStorage.getItem('projectList').split(',').map(item => parseInt(item));
                    projectList = projectList.filter(item => auth.includes(item.projectId));
                }
                if(projectList.length !== 0) { setProjectCreateDiv(false); }
                setProjectData(projectList);
                setCheckSelects({projectList : projectList.map(item => ({name : item.name, value : item.projectId}))});
                setEditableProjectList(false);
            });
    }, [location]);
    const clickProjectEditButton = function () {
        setProjectDataEdit([ ...JSON.parse(JSON.stringify(projectData))]);
        setEditableProjectList(true);
    };
    const clickProjectCancelButton = function () {
        if(projectData.length === 0) { setProjectCreateDiv(true); }
        setEditableProjectList(false);
    };
    const clickProjectAddButton = function () {
        let tempData = [ ...projectDataEdit ];
        tempData.push({ name: "", createDate: "" });
        setProjectDataEdit(tempData);
    };
    const handleProjectChange = function (row, col, value) {
        let tempData = [ ...projectDataEdit ];
        tempData[row][col] = value;
        tempData[row].updated = true;
        setProjectDataEdit(tempData);
    };
    const handleProjectRemove = function (row) {
        let tempData = [ ...projectDataEdit ];
        tempData[row].removed = true;
        setRemovedProjectList([...removedProjectList, tempData.splice(row, 1)[0]]);
        setProjectDataEdit(tempData);
    };
    const clickProjectCreateButton = function () {
        setProjectCreateDiv(false);
        clickProjectEditButton();
    };
    const onProjectConfirm = function (result) {
        if(result) {
            let resultData = projectDataEdit.concat(removedProjectList);
            axios.post('data/project/listedit', [ ...resultData.filter(project => project.updated || project.removed)])
                .then(response => {
                    setProjectData(response.data);
                    setCheckSelects({projectList : response.data.map(item => ({name : item.name, value : item.projectId}))});
                    setEditableProjectList(false);
                });
        }
        showProjectConfirm(false);
    };

    // user
    useEffect(() => {
        axios.get('data/auth/list')
            .then(response => {
                if(response.data.length !== 0) { setUserCreateDiv(false); }
                setUserData(response.data);
                setEditableUserList(false);
            });
    }, [location]);
    const clickUserEditButton = function () {
        setUserDataEdit([ ...JSON.parse(JSON.stringify(userData))]);
        setEditableUserList(true);
    };
    const clickUserCancelButton = function () {
        if(userData.length === 0) { setUserCreateDiv(true); }
        setEditableUserList(false);
    };
    const clickUserAddButton = function () {
        let tempData = [ ...userDataEdit ];
        tempData.push({ userId: "", password: "", projectList:[] });
        setUserDataEdit(tempData);
    };
    const handleUserChange = function (row, col, value) {
        let tempData = [ ...userDataEdit ];
        tempData[row][col] = value;
        tempData[row].updated = true;
        setUserDataEdit(tempData);
    };
    const handleUserRemove = function (row) {
        let tempData = [ ...userDataEdit ];
        tempData[row].removed = true;
        setRemovedUserList([ ...removedUserList, tempData.splice(row, 1)[0]]);
        setUserDataEdit(tempData);
    };
    const clickUserCreateButton = function () {
        setUserCreateDiv(false);
        clickUserEditButton();
    };
    const onUserConfirm = function (result) {
        if(result) {
            let resultData = userDataEdit.concat(removedUserList);
            axios.post('data/auth/listedit', [ ...resultData.filter(user => user.updated || user.removed )])
                .then(response => {
                    setUserData(response.data);
                    setEditableUserList(false);
                });
        }
        showUserConfirm(false);
    };

    return (<>
        <GridContainer>
            <GridItem md={6} className={classes.collapsed}>
                <div className={classes.cellContent} style={{ height: '100vh'}}>
                    <h4><b>고객사 목록</b></h4>
                    {showProjectCreateDiv? <>
                        <div className={classes.createScenario}>
                            <div className={classes.dropzoneText}>
                                <div>등록된 고객사가 없습니다.<br />생성하기 버튼을 눌러 고객사 정보를 등록해주세요.</div>
                                <Button color="info" style={{ marginTop: 10 }} onClick={clickProjectCreateButton}>생성하기</Button>
                            </div>
                        </div>
                    </>:<>
                        {editableProjectList? <>
                            <Confirm show={projectConfirm} title="수정 사항 저장" text="수정된 고객사 목록을 저장합니다."
                                onConfirm={onProjectConfirm} confirmText="저장" type="info" />
                            <EditTable
                                tableHeaderColor="info"
                                tableHead={['프로젝트 명', '생성일']}
                                tableCols={['name', 'createDate']}
                                tableData={projectDataEdit}
                                underlineColor="info"
                                onChange={handleProjectChange}
                                onRemove={handleProjectRemove}
                                fixed={['createDate']}/>
                            <Button color="info" className={classes.right} size="sm" onClick={clickProjectAddButton}>추가</Button>
                            <Button color="danger" className={classes.right} size="sm" onClick={clickProjectCancelButton}>취소</Button>
                            <Button color="success" className={classes.right} size="sm" onClick={e => { showProjectConfirm(true); }}>저장</Button>
                        </> : <>
                            <Table striped
                                tableHeaderColor="info"
                                tableHead={['프로젝트 명', '생성일']}
                                tableCols={['name', 'createDate']}
                                tableData={projectData}/>
                            <Button color="infoOutline" className={classes.right} size="sm" onClick={clickProjectEditButton}>수정</Button>
                        </>}
                    </>}
                </div>
            </GridItem>
            <GridItem md={6} className={classes.collapsed}>
                <div className={classes.cellContent} style={{ height: '100vh'}}>
                    <h4><b>사용자 목록</b></h4>
                    {showUserCreateDiv? <>
                        <div className={classes.createScenario}>
                            <div className={classes.dropzoneText}>
                                <div>등록된 사용자가 없습니다.<br />생성하기 버튼을 눌러 사용자 정보를 등록해주세요.</div>
                                <Button color="info" style={{ marginTop: 10 }} onClick={clickUserCreateButton}>생성하기</Button>
                            </div>
                        </div>
                    </>:<>
                        {editableUserList? <>
                            <Confirm show={userConfirm} title="수정 사항 저장" text="수정된 사용자 목록을 저장합니다."
                                onConfirm={onUserConfirm} confirmText="저장" type="info" />
                            <EditTable
                                tableHeaderColor="info"
                                tableHead={['아이디', '고객사', '비밀번호']}
                                tableCols={['userId', 'projectList', 'password']}
                                tableData={userDataEdit}
                                underlineColor="info"
                                onChange={handleUserChange}
                                onRemove={handleUserRemove}
                                checkSelects={checkSelects}
                                fixed={['createDate']}/>
                            <Button color="info" className={classes.right} size="sm" onClick={clickUserAddButton}>추가</Button>
                            <Button color="danger" className={classes.right} size="sm" onClick={clickUserCancelButton}>취소</Button>
                            <Button color="success" className={classes.right} size="sm" onClick={e => { showUserConfirm(true); }}>저장</Button>
                        </> : <>
                            <Table striped
                                tableHeaderColor="info"
                                tableHead={['아이디', '고객사']}
                                tableCols={['userId', 'projectName']}
                                tableData={userData}/>
                            <Button color="infoOutline" className={classes.right} size="sm" onClick={clickUserEditButton}>수정</Button>
                        </>}
                    </>}
                </div>
            </GridItem>
        </GridContainer>
    </>);
}